// extracted by mini-css-extract-plugin
module.exports = {"placeholderContainer":"placeholder_placeholderContainer__V2igx"};